import {EntityBase} from "../../../shared/entity/EntityBase";
import dayjs from "dayjs";

const MERGE_EVENT_MASTER_FIELDS = {
    seq: { type: Number, defaultValue: 0 },
    index: { type: Number, defaultValue: 0 },
    mergeEventType: { type: Number, defaultValue: 1 },
    openLevel: { type: Number, defaultValue: 1 },
    name: { defaultValue: '' },
    begin: { type: Number, defaultValue: dayjs().hour(9).startOf('hour').unix() },
    end: { type: Number, defaultValue: dayjs().add(1, 'day').hour(8).endOf('hour').unix() },
    onOff: { type: Number, defaultValue: 0 }, // 0: off, 1: on
}

export class MergeEventMasterEntity extends EntityBase {
    constructor(data = {}) {
        super(data, MERGE_EVENT_MASTER_FIELDS);

        this.errors = [
            {condition: () => this.index === 0, message: '인덱스가 없습니다.'},
            {condition: () => this.mergeEventType === 0, message: '머지 이벤트 타입이 없습니다.'},
        ];
    }
}